/** @jsxImportSource @emotion/react */
import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import { MessageLeft, MessageRight } from "./messages.jsx";
import Spinner from "./Spinner.js";

export default function ChatContainer({
  covloader,
  loadversion,
  setloadversion,
  setGcs_generated_documents,
  setVersion,
  messages,
  isloading,
  handlesetchat,
  sdata,
  handlealldocs,
  user_edit,
  msgloadtext,
  citations,
  isApiError,
  isTimeoutError,
  responseTime,
  handleEditUserMessage,
}: any) {
  const [elapsedTime, setElapsedTime] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (isloading) {
      setElapsedTime(0);
      timerRef.current = setInterval(() => {
        setElapsedTime((prev) => prev + 1);
      }, 1000);
    } else {
      clearInterval(timerRef.current);
    }

    return () => clearInterval(timerRef.current);
  }, [isloading]);

  const containerRef = useRef(null);

  useEffect(() => {
    // Scroll to the bottom of the container
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [messages]);
  useEffect(() => {
    // Scroll to the bottom of the container
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, []);
  return (
    <>
      <Box sx={{ height: "100%", padding: "1rem" }}>
        <Box ref={containerRef} sx={{ height: "99%", overflow: "auto" }}>
          {messages.map((msg, index) => (
            <div key={index}>
              {msg.displayName === "response" ? (
                <MessageLeft
                  loading={isloading}
                  loadversion={loadversion}
                  setloadversion={setloadversion}
                  setGcs_generated_documents={setGcs_generated_documents}
                  setVersion={setVersion}
                  handlesetchat={handlesetchat}
                  sdata={sdata}
                  handlealldocs={handlealldocs}
                  user_edit={user_edit}
                  covloader={covloader}
                  message={msg.message}
                  displayName="response"
                  citations={msg.citations}
                  isApiError={isApiError}
                  isTimeoutError={isTimeoutError}
                  responseTime={msg.responseTime || responseTime}
                  messageId={msg.messageId}
                />
              ) : (
                <>
                  <MessageRight
                    message={msg.message}
                    displayName="userprompt"
                    stoppedByUser={msg?.stoppedByUser}
                    isLastUserMessage={index === messages.map(m => m.displayName).lastIndexOf('userprompt')}
                    onEdit={handleEditUserMessage}
                    conversationId={sdata[0]}
                  />
                </>
              )}
            </div>
          ))}
          {isloading && <Spinner elapsedTime={elapsedTime} />}
        </Box>
      </Box>
    </>
  );
}
